// Shared header constants used by the desktop nav, mobile nav, breadcrumb, and account menu.
export const ROLE_DOT   = { admin: 'bg-violet-500', manager: 'bg-amber-500', user: 'bg-zinc-400' };

// Pathname → i18n key for the breadcrumb on every /settings/* page (render with t()).
export const SETTINGS_LABELS = {
  '/settings/employees':       'settings.employees',
  '/settings/users':           'settings.users',
  '/settings/roles':           'settings.roles',
  '/settings/departments':     'settings.departments',
  '/settings/workflow':        'settings.workflow',
  '/settings/signature':       'settings.signature',
  '/settings/audit-log':       'settings.auditLog',
  '/settings/backup':          'settings.backup',
  '/settings/labels':          'settings.labels',
  '/settings/email':           'settings.email',
  '/settings/email-templates': 'settings.emailTemplates',
  '/settings/email-log':       'settings.emailLog',
  '/settings/order-categories': 'settings.orderCategories',
  '/settings/holidays':        'settings.holidays',
};

/** Longest-prefix match so /settings/email-templates doesn't resolve to メール設定. Returns an i18n key. */
export function getSettingsSubLabel(pathname) {
  const key = Object.keys(SETTINGS_LABELS)
    .sort((a, b) => b.length - a.length)
    .find((k) => pathname.startsWith(k));
  return key ? SETTINGS_LABELS[key] : null;
}

export function userInitial(user) {
  const s = (user && typeof user === 'object' ? (user.name || user.email || '?') : '?');
  return s.slice(0, 1).toUpperCase();
}

export function userRoleKey(user) {
  return (user && typeof user === 'object') ? (user.role || 'user') : 'user';
}
